<template>
  <div class="p-6">
    <!-- 헤더 섹션 -->
    <div class="flex items-center justify-between mb-6">
      <h1 class="text-xl font-bold">미분류 호가 조회</h1>
      <NavigationDateSelector v-model="selectedDate" @dateSelected="selectDate" />
    </div>

    <!-- 테이블 섹션 -->
    <div class="bg-white border rounded-lg overflow-hidden">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              번호
            </th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              내용
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="(content, index) in uniqueContents" :key="index">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              {{ index + 1 }}
            </td>
            <td class="px-6 py-4 text-sm text-gray-900">
              {{ content }}
            </td>
          </tr>
          <tr v-if="uniqueContents.length === 0">
            <td colspan="2" class="px-6 py-4 text-center text-gray-500">
              데이터가 없습니다
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { getTodayStr } from '@/utils/util';
import chatService from '@/service/chatService';
import NavigationDateSelector from '@/components/NavigationDateSelector.vue';

export default {
  name: 'UncategorizedChatView',
  components: {
    NavigationDateSelector,
  },
  setup() {
    const selectedDate = ref(getTodayStr());
    const uncategorizedChats = ref([]);

    const uniqueContents = computed(() => {
      const contents = uncategorizedChats.value.map(chat => chat.content);
      return [...new Set(contents)];
    });

    const formatDateDisplay = dateStr => {
      const date = new Date(dateStr);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const dayOfWeek = new Intl.DateTimeFormat('ko-KR', {
        weekday: 'short',
      }).format(date);
      return `${month}월 ${day}일 (${dayOfWeek})`;
    };

    const fetchUncategorizedAsks = async date => {
      try {
        uncategorizedChats.value =
          await chatService.fetchUncategorizedChats(date);
      } catch (error) {
        console.error('Error fetching uncategorized asks:', error);
      }
    };

    const selectDate = async date => {
      selectedDate.value = date;
      await fetchUncategorizedAsks(date);
    };

    onMounted(async () => {
      await fetchUncategorizedAsks(selectedDate.value);
    });

    return {
      selectedDate,
      uniqueContents,
      formatDateDisplay,
      selectDate,
    };
  },
};
</script>
